import { IVideoLibraryResponseDTO } from '@/api/video/dtos/video-library-response-dto';
import { applyTimezoneOffset } from '@/common/timezone/timezone.helper';
import { IVideo } from '@/types/Video';

export class VideoHelper {
  static correctDates(payload: IVideoLibraryResponseDTO) {
    return {
      videos: payload.videos.map((video: IVideo) => {
        return { ...video, createdAt: applyTimezoneOffset(video.createdAt, true) };
      }),
      totalCount: payload.totalCount,
    };
  }
}
